interface SlugResource {
  slug: string;
}

export const getSlug = (resource?: SlugResource | null): string => resource?.slug || '';
